export default {
    baseName: "/"
};
